export default "assets/images/logos_maestro-8057fbf8.png";